<template>
<el-dialog title="完善个人信息" :visible.sync="visible" width="35%" :before-close="beforeClose">
    <el-form ref="form" :model="iform" label-width="90px">
        <el-form-item label="真实姓名：">
            <el-input v-model="iform.realname" placeholder="身份证上的姓名"></el-input>
        </el-form-item>
        <el-form-item label="身份证号：">
            <el-input v-model="iform.cardmum" placeholder="身份证号码"></el-input>
        </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
        <el-button @click="close">取 消</el-button>
        <el-button type="primary" @click="onSubmit">确 定</el-button>
    </div>
</el-dialog>
</template>

<script>
import Y from '@/utils/Y'

export default {
    props: {
    },
    data() {
        return {
            visible: false,
            iform: {
                realname: '',
                cardmum: '',
            }
        }
    },
    components: {},
    methods:{
        
        onSubmit () {

        },

        /**
         * 开启窗口
        */
        open () {
            this.visible = true
        },

        /**
         * 关闭窗口
        */
        close () {
            this.visible = false
        },

        // 关闭窗口
        beforeClose (done) {
            done()
        }
    }
}
</script>

<style lang="less" scoped>
</style>